import React from "react";
import { EditorCursorPopup } from "../../popup/components/EditorCursorPopup/EditorCursorPopup";
import { menuEnabled } from "../state";
import { FormattingToolbar } from "./FormattingToolbar/FormattingToolbar";
export const EditorFloatingToolbarPluginView = ({ view, commands, items, showDividers }) => {
    const { state } = view;
    const { selection } = state;
    const handleCommand = (command) => {
        command.run(view.state, view.dispatch.bind(view), view);
    };
    if (shouldHideMenu(view, state, selection)) {
        return null;
    }
    return (React.createElement(EditorCursorPopup, { view: view, from: selection.from, to: selection.to, offsetTop: 16 },
        React.createElement(FormattingToolbar, { state: state, commands: commands, showDividers: showDividers, mode: "floating", items: items, onCommand: handleCommand })));
};
function shouldHideMenu(view, state, selection) {
    return (!menuEnabled(state) ||
        selection.empty ||
        selection.node !== undefined ||
        !view.editable ||
        !view.hasFocus());
}
